'use strict'

class UploadToken
  constructor: (transfer, region, confirmOptions) ->
    @region = region
    @confirmOptions = confirmOptions
    @_internals =
      transfer: transfer
      serverData: null
      isConfirmed: false
      compression: {}
      outstandingBytes: 0
      parallelUploads: 0
      xhrs: []

  getId: ->
    @_internals.serverData.id || @_internals.transfer.id

  getShareUrl: ->
    @_internals.serverData.shareUrl || @_internals.transfer.shareUrl

  getTransferToken: ->
    @_internals.serverData.token

  isConfirmed: ->
    @_internals.isConfirmed

  isAborted: ->
    @_internals.isAborted

  getUrl: ->
    "#{@_internals.serverData.url}/#{@_internals.serverData.keyPrefix}"

  getOutstandingBytes: ->
    @_internals.outstandingBytes

  getParallelUploads: ->
    @_internals.parallelUploads

  getAvailableUntil: ->
    new Date @_internals.serverData.expires

  abort: ->
    # Mark the token as aborted
    @_internals.isAborted = true

    # Cancel the transfer ping
    if @ping
      clearInterval @ping
      delete @ping

    # Cancel all pending uploads (if a token was attached)
    xhrs = @_internals.xhrs
    if xhrs?
      # The XHR unregisters itself from the XHRs array
      while xhrs.length > 0
        xhrs[0].abort()

export default UploadToken
